import React from 'react';
import { ILookupPanelProperties } from './LookupPanel.properties';
import inlineStyles from './LookupPanel.styles';
import Paper from '@material-ui/core/Paper';
import classNames from 'classnames';
import ChevronLeftIcon from '@markinson/uicomponents-v2/SvgIcons/ChevronLeft';
import ChevronRightIcon from '@markinson/uicomponents-v2/SvgIcons/ChevronRight';
import { withStyles } from '@material-ui/core/styles';

const getDragIconStyle = (isDisabled: boolean) => {
  return {
    ...inlineStyles.closedDragIcon,
    ...(isDisabled ? inlineStyles.lookupDragControllerDisabled : {})
  };
};

const LookupPanel = (props: ILookupPanelProperties) => {
    const { classes, open, setOpen, isPopover, children, isLookupPanelDisabled = false } = props;

    const handleKeyPress = (event) => {
        if (event.ctrlKey && event.key === 'Home') {
            event.preventDefault();
            setOpen(true);

            return;
        }

        if (event.key === 'Escape') {
            event.preventDefault();
            if (!isPopover) {
                setOpen(false);
            }

            return;
        }
    };

    React.useEffect(
        () => {

            document.addEventListener('keydown', handleKeyPress);

            return () => {
                document.removeEventListener('keydown', handleKeyPress);
            };
        },
        [handleKeyPress]
    );

    return open ? (
        <div className={classes.lookupInner}>
            <Paper style={inlineStyles.lookupContainerStyle} square={true}>
                {children}
            </Paper>

            <Paper
                className={classes.lookupDragController}
                classes={{
                    root: classNames({ [classes.openedDragController]: open })
                }}
                square={true}
                onClick={() => { setOpen(!open); }}
            >
                <ChevronLeftIcon style={inlineStyles.dragIcon} />
            </Paper>
        </div>
    ) : (
        <Paper
            className={classNames(classes.lookupDragController, isLookupPanelDisabled && classes.lookupDragControllerDisabled)}
            classes={{
                root: classNames({ [classes.openedDragController]: open })
            }}
            square={true}
            onClick={() => { setOpen(!open); }}
        >
            <ChevronRightIcon style={getDragIconStyle(isLookupPanelDisabled)} />
        </Paper>
    );
};

export default withStyles(inlineStyles, { index: 1 })(LookupPanel);
